module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-75Bd-be00ab95935181bb628f81849caef6b4.woff";